import { render } from "./Sop.vue?vue&type=template&id=1ee82b6d"
import script from "./Sop.vue?vue&type=script&lang=js"
export * from "./Sop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__